var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',[_c('v-alert',{attrs:{"color":"#C51162","dark":"","icon":"mdi-alert-octagon","border":"right"}},[_vm._v(" 404 - Página não encontrada ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }